// Third party library imports
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';

// Zopup library imports
import { CompanyStore } from '@zopup/zop-apis';
import { StorageKey, StorageService } from '@zopup/zop-shared';
import { BranchDto, CompanyDto, TenantDto } from '@zopup/zop-types';
import { zopAnimations, ZopBrandingService } from '@zopup/zop-ux-core';

// Internal project imports

@Component({
    selector: 'app-company-branch-selection',
    templateUrl: './company-branch-selection.component.html',
    styleUrls: ['./company-branch-selection.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: zopAnimations,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        RouterModule,
    ],
})
export class CompanyBranchSelectionComponent implements OnInit {
    readonly companyStore = inject(CompanyStore);
    readonly branding = inject(ZopBrandingService);

    selectedTenant: TenantDto;

    constructor(
        private _router: Router,
        private _storageService: StorageService
    ) {}

    ngOnInit() {
        this.selectedTenant = this._storageService.getItem<TenantDto>(
            StorageKey.tenant
        );
        this.getCompanyDetails();
    }

    async getCompanyDetails(): Promise<void> {
        try {
            await this.companyStore.getById(this.selectedTenant.id);
            this._storageService.setItem<CompanyDto>(
                StorageKey.company,
                this.companyStore.selectedCompany()
            );

            if (this.companyStore.selectedCompany().branches.length == 1) {
                this.selectBranch(
                    this.companyStore.selectedCompany().branches[0]
                );
            }
        } catch (ex) {
            console.error(
                'Exception in company-branch-selection.component getCompanyDetails() =>'
            );
            console.error(ex);
        }
    }

    onChangeTenant() {
        this._router.navigateByUrl('/tenant-selection');
    }
    selectBranch(branch: BranchDto | null) {
        if (!branch) {
            return;
        }
        // TODO Add to storage - selected branch
        this._storageService.setItem<BranchDto>(StorageKey.branch, branch);
        this._router.navigateByUrl('/home');
    }
}
